import React from "react";
import { cn } from "../lib/utils";

export const Small: React.FC<React.HTMLAttributes<HTMLElement>> = ({
  children,
  className,
  ...props
}) => (
  <small
    className={cn("font-body text-sm font-medium leading-none", className)}
    {...props}
  >
    {children}
  </small>
);
